module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/editar-convenio-credit/editar-convenio-credit.component.scss
// module id = ./src/app/components/tools/modals/editar-convenio-credit/editar-convenio-credit.component.scss
// module chunks = main